module.exports = __webpack_public_path__ + "img/Curacao.6a1f0c54.png";